import appConfig from './apiConfig';

export const fetchAllMembersApi =(token)=>{

const headers = Object.assign({'content-type':'application/json',
                               'accept':'*/*'
                           });
const request= new Request( appConfig.siteURL+'getAllUserProfile/'+ token, {
  method : "GET",
  headers : headers,
});

return fetch(request).then(response => {
    return  response.json().then(membersDataResponse => {
      return membersDataResponse;
    });
  }).catch(error => {
   return error;
 });
}


export const fetchNewMembersApi =()=>{

const headers = Object.assign({'content-type':'application/json',
                               'accept':'*/*'
                           });
const request= new Request( appConfig.siteURL+'getAllNewUserProfile', {
  method : "GET",
  headers : headers,
});

return fetch(request).then(response => {
    return  response.json().then(newMembersDataResponse => {
      return newMembersDataResponse;
    });
  }).catch(error => {
   return error;
 });
}


export const approveMembersApi =(id)=>{

const headers = Object.assign({'content-type':'application/json',
                               'accept':'*/*'
                           });
const request= new Request( appConfig.siteURL+'approveMembers/'+id, {
  method : "POST",
  headers : headers,
});

return fetch(request).then(response => {
    return  response.json().then(approvedMembersResponse => {
      return approvedMembersResponse;
    });
  }).catch(error => {
   return error;
 });
}

export const updateProfileApi =( data)=>{
  let objProfile =  JSON.stringify(data);

const headers = Object.assign({'content-type':'application/json',
                               'accept':'*/*'
                            // 'Authorization' : 'Bearer '+ access_token
                           });
const request= new Request( appConfig.siteURL+'updateProfile/'+data.profileId, {
  method : "POST",
  headers : headers,
  body : objProfile
});

return fetch(request).then(response => {
    return  response.json().then(updateProfileResponse => {
      return updateProfileResponse;
    });
  }).catch(error => {
   return error;
 });
}

//showTransactionByuserIDApi
export const showTransactionByuserIDApi =(id)=>{

  const headers = Object.assign({'content-type':'application/json',
                                 'accept':'*/*'
                             });
  const request= new Request( appConfig.siteURL+'fetchUserTraction/'+id, {
    method : "GET",
    headers : headers
  });
  
  return fetch(request).then(response => {
      return  response.json().then(approvedMembersResponse => {
        return approvedMembersResponse;
      });
    }).catch(error => {
     return error;
   });
  }


// WEBPACK FOOTER //
// ./src/api/membersApi.js